/*
 *
 * HomePage actions
 *
 */

const SCOPE = 'app/HomePage/';
export const ActionTypes = {
    SET_PAGE_IS_LOADED: `${SCOPE}SET_PAGE_IS_LOADED`,
    FETCH_PAGE: `${SCOPE}FETCH_PAGE`,
    FETCH_PAGE_STARTED: `${SCOPE}FETCH_PAGE_STARTED`,
    FETCH_PAGE_SUCCESSFULLY: `${SCOPE}FETCH_PAGE_SUCCESSFULLY`,
    FETCH_PAGE_FAILED: `${SCOPE}FETCH_PAGE_FAILED`,
    FETCH_PAGE_CANCELLED: `${SCOPE}FETCH_PAGE_CANCELLED`,

    SET_BLOGS_IS_LOADED: `${SCOPE}SET_BLOGS_IS_LOADED`,
    FETCH_BLOGS: `${SCOPE}FETCH_BLOGS`,
    FETCH_BLOGS_STARTED: `${SCOPE}FETCH_BLOGS_STARTED`,
    FETCH_BLOGS_SUCCESSFULLY: `${SCOPE}FETCH_BLOGS_SUCCESSFULLY`,
    FETCH_BLOGS_FAILED: `${SCOPE}FETCH_BLOGS_FAILED`,
    FETCH_BLOGS_CANCELLED: `${SCOPE}FETCH_BLOGS_CANCELLED`,

    SET_STORIES_IS_LOADED: `${SCOPE}SET_STORIES_IS_LOADED`,
    FETCH_STORIES: `${SCOPE}FETCH_STORIES`,
    FETCH_STORIES_STARTED: `${SCOPE}FETCH_STORIES_STARTED`,
    FETCH_STORIES_SUCCESSFULLY: `${SCOPE}FETCH_STORIES_SUCCESSFULLY`,
    FETCH_STORIES_FAILED: `${SCOPE}FETCH_STORIES_FAILED`,
    FETCH_STORIES_CANCELLED: `${SCOPE}FETCH_STORIES_CANCELLED`,

    SET_PROMO_PRICES_IS_LOADED: `${SCOPE}SET_PROMO_PRICES_IS_LOADED`,
    RESET_PROMO_PRICES: `${SCOPE}RESET_PROMO_PRICES`,
    FETCH_PROMO_PRICES: `${SCOPE}FETCH_PROMO_PRICES`,
    FETCH_PROMO_PRICES_STARTED: `${SCOPE}FETCH_PROMO_PRICES_STARTED`,
    FETCH_PROMO_PRICES_SUCCESSFULLY: `${SCOPE}FETCH_PROMO_PRICES_SUCCESSFULLY`,
    FETCH_PROMO_PRICES_FAILED: `${SCOPE}FETCH_PROMO_PRICES_FAILED`,
    FETCH_PROMO_PRICES_CANCELLED: `${SCOPE}FETCH_PROMO_PRICES_CANCELLED`,

    SET_POPULAR_DESTINATIONS_IS_LOADED: `${SCOPE}SET_POPULAR_DESTINATIONS_IS_LOADED`,
    FETCH_POPULAR_DESTINATIONS: `${SCOPE}FETCH_POPULAR_DESTINATIONS`,
    FETCH_POPULAR_DESTINATIONS_STARTED: `${SCOPE}FETCH_POPULAR_DESTINATIONS_STARTED`,
    FETCH_POPULAR_DESTINATIONS_SUCCESSFULLY: `${SCOPE}FETCH_POPULAR_DESTINATIONS_SUCCESSFULLY`,
    FETCH_POPULAR_DESTINATIONS_FAILED: `${SCOPE}FETCH_POPULAR_DESTINATIONS_FAILED`,
    FETCH_POPULAR_DESTINATIONS_CANCELLED: `${SCOPE}FETCH_POPULAR_DESTINATIONS_CANCELLED`,
};

/**
 * Page
 */
export const setPageIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_PAGE_IS_LOADED, isLoaded });
export const fetchPage = () => ({ type: ActionTypes.FETCH_PAGE });
export const fetchPageStarted = () => ({ type: ActionTypes.FETCH_PAGE_STARTED });
export const fetchPageSuccessfully = (res) => ({
    type: ActionTypes.FETCH_PAGE_SUCCESSFULLY,
    res,
});
export const fetchPageFailed = (error) => ({
    type: ActionTypes.FETCH_PAGE_FAILED,
    error,
});
export const fetchPageCancelled = () => ({
    type: ActionTypes.FETCH_PAGE_CANCELLED,
});

/**
 * Blogs
 */
export const setBlogsIsLoaded = (isLoaded) => ({ type: ActionTypes.SET_BLOGS_IS_LOADED, isLoaded });
export const fetchBlogs = () => ({ type: ActionTypes.FETCH_BLOGS });
export const fetchBlogsStarted = () => ({ type: ActionTypes.FETCH_BLOGS_STARTED });
export const fetchBlogsSuccessfully = (res) => ({
    type: ActionTypes.FETCH_BLOGS_SUCCESSFULLY,
    res,
});
export const fetchBlogsFailed = (error) => ({
    type: ActionTypes.FETCH_BLOGS_FAILED,
    error,
});
export const fetchBlogsCancelled = () => ({
    type: ActionTypes.FETCH_BLOGS_CANCELLED,
});

/**
 * Stories
 */
export const setStoriesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_STORIES_IS_LOADED,
    isLoaded,
});
export const fetchStories = () => ({ type: ActionTypes.FETCH_STORIES });
export const fetchStoriesStarted = () => ({ type: ActionTypes.FETCH_STORIES_STARTED });
export const fetchStoriesSuccessfully = (res) => ({
    type: ActionTypes.FETCH_STORIES_SUCCESSFULLY,
    res,
});
export const fetchStoriesFailed = (error) => ({
    type: ActionTypes.FETCH_STORIES_FAILED,
    error,
});
export const fetchStoriesCancelled = () => ({
    type: ActionTypes.FETCH_STORIES_CANCELLED,
});

/**
 * PromoPrices
 */
export const setPromoPricesIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_PROMO_PRICES_IS_LOADED,
    isLoaded,
});
export const resetPromoPrices = () => ({ type: ActionTypes.RESET_PROMO_PRICES });
export const fetchPromoPrices = () => ({ type: ActionTypes.FETCH_PROMO_PRICES });
export const fetchPromoPricesStarted = () => ({ type: ActionTypes.FETCH_PROMO_PRICES_STARTED });
export const fetchPromoPricesSuccessfully = (res) => ({
    type: ActionTypes.FETCH_PROMO_PRICES_SUCCESSFULLY,
    res,
});
export const fetchPromoPricesFailed = (error) => ({
    type: ActionTypes.FETCH_PROMO_PRICES_FAILED,
    error,
});
export const fetchPromoPricesCancelled = () => ({
    type: ActionTypes.FETCH_PROMO_PRICES_CANCELLED,
});
/**
 * Popular destinations
 */
export const setPopularDestintaionsIsLoaded = (isLoaded) => ({
    type: ActionTypes.SET_POPULAR_DESTINATIONS_IS_LOADED,
    isLoaded,
});
export const fetchPopularDestintaions = () => ({ type: ActionTypes.FETCH_POPULAR_DESTINATIONS });
export const fetchPopularDestintaionsStarted = () => ({
    type: ActionTypes.FETCH_POPULAR_DESTINATIONS_STARTED,
});
export const fetchPopularDestintaionsSuccessfully = (destinations) => ({
    type: ActionTypes.FETCH_POPULAR_DESTINATIONS_SUCCESSFULLY,
    destinations,
});
export const fetchPopularDestintaionsFailed = (error) => ({
    type: ActionTypes.FETCH_POPULAR_DESTINATIONS_FAILED,
    error,
});
export const fetchPopularDestintaionsCancelled = () => ({
    type: ActionTypes.FETCH_POPULAR_DESTINATIONS_CANCELLED,
});
